import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    useGetCountProductsQuery,
    useGetPresentsProductsQuery,
    useUpdateCartInfoMutation,
} from '@/shared/api-rtk/api-list/cartApi'
import classNames from 'classnames'
import { changeCartLoading } from '@/shared/store/slice/cartSlice'
import Link from 'next/link'
import { PromoField } from '@/features/cart-page/promo-field/index.jsx'

export const OrdersCart = React.memo(
    ({ data, refetch, codeAplied, userInfo }) => {
        // orders - массив продуктов, добавленных в корзину
        const dispatch = useDispatch()

        const [updateCart, { isLoading: isLoadingUpdateCart }] =
            useUpdateCartInfoMutation() // метод отправки данных по корзине на бек
        const { refetch: refetchCount } = useGetCountProductsQuery()

        const { cartLoading: isLoading } = useSelector(
            (state) => state.cartActions
        )

        const { refetch: refetchProductsToPresent } =
            useGetPresentsProductsQuery()

        const update = async (data) => {
            dispatch(changeCartLoading(true))
            await updateCart(data)
            await refetch()
            await refetchCount()
            await refetchProductsToPresent()
            dispatch(changeCartLoading(false))
        }

        const handleIncrement = (cartItemCode) => {
            const copy_cart = { ...data.cart }
            copy_cart[cartItemCode] = copy_cart[cartItemCode] + 1
            try {
                update({
                    ...data,
                    cart: copy_cart,
                    cart_action: 'Increment',
                    cartItemCode,
                    userInfo,
                })
            } catch (error) {}
        }

        const handleDecrement = (cartItemCode) => {
            const copy_cart = { ...data.cart }
            copy_cart[cartItemCode] = copy_cart[cartItemCode] - 1
            try {
                update({
                    ...data,
                    cart: copy_cart,
                    cart_action: 'Decrement',
                    cartItemCode,
                    userInfo,
                })
            } catch (error) {
                console.error(error)
            }
        }

        const deleteItem = async (cartItemCode) => {
            const copy_cart = { ...data.cart }
            copy_cart[cartItemCode] = 0
            try {
                update({
                    ...data,
                    cart: copy_cart,
                    cart_action: 'deleteItem',
                    cartItemCode,
                    userInfo,
                })
            } catch (error) {
                console.error(error)
            }
        }

        return (
            <div className={'OrdersCart'}>
                {data?.products?.map((itemCart) => {
                    const itemUrl = itemCart.href.split('/').reverse()[0]
                    const cert =
                        itemCart?.name == 'Подарочный сертификат' ? true : false
                    return (
                        <div
                            key={itemCart.product_id + itemCart.total}
                            className={'item-cart'}
                        >
                            <div className={'about-item'}>
                                <img
                                    className="cart-thumb"
                                    src={itemCart.thumb}
                                    alt=""
                                />
                                <div className={'text-item'}>
                                    <Link href={'/' + itemUrl}>
                                        {itemCart.name}
                                    </Link>
                                    {itemCart.option.map((option) => (
                                        <div>
                                            {option.name}: {option.value}
                                        </div>
                                    ))}
                                    <span>Артикул: {itemCart.articul}</span>
                                </div>
                            </div>
                            <div className={'info-item'}>
                                <div className={'info price'}>
                                    <h2>
                                        {!itemCart.isPresent
                                            ? parseInt(
                                                  itemCart.price
                                              ).toLocaleString()
                                            : 1}{' '}
                                        ₽
                                    </h2>
                                </div>
                                <div
                                    className={classNames(
                                        'info',
                                        'count',
                                        'position-relative',
                                        isLoading ? 'count-opacity ' : ''
                                    )}
                                >
                                    <div
                                        className={classNames(
                                            isLoading
                                                ? 'cart-count-dis'
                                                : 'cart-count-en'
                                        )}
                                    ></div>
                                    {!itemCart.isPresent && !cert && (
                                        <span
                                            onClick={() =>
                                                handleDecrement(itemCart.key)
                                            }
                                        >
                                            -
                                        </span>
                                    )}
                                    <h2>{itemCart.quantity}</h2>
                                    {!itemCart.isPresent &&
                                        itemCart?.stock_quantity >
                                            itemCart.quantity &&
                                        !cert && (
                                            <span
                                                onClick={() =>
                                                    handleIncrement(
                                                        itemCart.key
                                                    )
                                                }
                                            >
                                                +
                                            </span>
                                        )}
                                </div>
                                <div className={'info sum'}>
                                    <h2>
                                        {parseInt(
                                            itemCart.total
                                        ).toLocaleString()}{' '}
                                        ₽
                                    </h2>
                                </div>

                                {!itemCart.isPresent && (
                                    <div
                                        className={classNames(
                                            'delete-action',
                                            'position-relative',
                                            isLoading ? 'count-opacity ' : ''
                                        )}
                                    >
                                        <svg
                                            onClick={() =>
                                                deleteItem(itemCart.key)
                                            }
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="35"
                                            height="36"
                                            viewBox="0 0 35 36"
                                            fill="none"
                                        >
                                            <rect
                                                y="0.354492"
                                                width="35"
                                                height="35"
                                                rx="5"
                                                fill="#040404"
                                            />
                                            <path
                                                d="M10.8359 12.8545H24.1693M12.5026 12.8545H22.5026V24.5212C22.5026 24.9814 22.1295 25.3545 21.6693 25.3545H13.3359C12.8757 25.3545 12.5026 24.9814 12.5026 24.5212V12.8545ZM15.0026 10.3545H20.0026C20.4628 10.3545 20.8359 10.7276 20.8359 11.1878V12.8545H14.1693V11.1878C14.1693 10.7276 14.5424 10.3545 15.0026 10.3545Z"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                )}

                                {itemCart.isPresent && (
                                    <div className={'cart-present'}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            viewBox="0 0 512 512"
                                            xmlSpace="preserve"
                                        >
                                            <path
                                                fill="#FFEE43"
                                                d="M480 252c-4.422 0-8 3.582-8 8H40c0-4.418-3.578-8-8-8s-8 3.582-8 8v208c0 22.055 17.945 40 40 40h384c22.055 0 40-17.945 40-40V260c0-4.418-3.578-8-8-8z"
                                            ></path>
                                            <path
                                                fill="#FFD100"
                                                d="M480 164H32c-17.648 0-32 14.355-32 32v48c0 17.645 14.352 32 32 32h448c17.648 0 32-14.355 32-32v-48c0-17.645-14.352-32-32-32z"
                                            ></path>
                                            <path
                                                fill="#FF4F19"
                                                d="M224 156H288V508H224z"
                                            ></path>
                                            <path
                                                fill="#E7001E"
                                                d="M224 407.313L288 471.313 288 448.688 224 384.688z"
                                            ></path>
                                            <path
                                                fill="#E7001E"
                                                d="M224 367.313L288 431.313 288 408.688 224 344.688z"
                                            ></path>
                                            <path
                                                fill="#E7001E"
                                                d="M288 231.313L288 208.688 235.313 156 224 156 224 167.313z"
                                            ></path>
                                            <path
                                                fill="#E7001E"
                                                d="M224 327.313L288 391.313 288 368.688 224 304.688z"
                                            ></path>
                                            <path
                                                fill="#E7001E"
                                                d="M224 424.688L224 447.313 284.688 508 288 508 288 488.688z"
                                            ></path>
                                            <path
                                                fill="#E7001E"
                                                d="M224 287.313L288 351.313 288 328.688 224 264.688z"
                                            ></path>
                                            <path
                                                fill="#E7001E"
                                                d="M224 207.313L288 271.313 288 248.688 224 184.688z"
                                            ></path>
                                            <path
                                                fill="#E7001E"
                                                d="M267.313 508L224 464.688 224 487.313 244.688 508z"
                                            ></path>
                                            <path
                                                fill="#E7001E"
                                                d="M224 247.313L288 311.313 288 288.688 224 224.688z"
                                            ></path>
                                            <g>
                                                <path
                                                    fill="#E7001E"
                                                    d="M424 291.969c-31.586 0-50.203-32.934-68.203-64.785-13.333-23.584-27.024-47.742-46.855-58.039 37.64-14.671 85.006-34.957 99.145-49.094 26.516-26.512 26.516-69.652 0-96.164-26.516-26.516-69.656-26.516-96.172 0C295.42 40.378 270.544 102.129 256 140.862c-14.544-38.732-39.42-100.484-55.914-116.975-26.516-26.516-69.656-26.516-96.172 0-26.516 26.512-26.516 69.652 0 96.164 14.139 14.137 61.504 34.423 99.145 49.094-19.832 10.297-33.522 34.455-46.855 58.039-18 31.852-36.617 64.785-68.203 64.785-6.625 0-12 5.371-12 12s5.375 12 12 12c45.586 0 68.703-40.895 89.094-76.977 14.836-26.238 28.844-51.023 46.906-51.023V188h64v-.031c18.063 0 32.07 24.785 46.906 51.023 20.391 36.082 43.508 76.977 89.094 76.977 6.625 0 12-5.371 12-12s-5.376-12-12.001-12zM328.883 40.855c8.578-8.578 19.844-12.863 31.117-12.863 11.266 0 22.539 4.289 31.117 12.863 17.156 17.156 17.156 45.07 0 62.227-12.219 12.219-69.773 36.078-115.156 52.926 16.844-45.383 40.703-102.934 52.922-115.153zm-208 0c8.578-8.578 19.844-12.863 31.117-12.863 11.266 0 22.539 4.289 31.117 12.863 12.219 12.219 36.078 69.77 52.922 115.152-45.383-16.848-102.938-40.707-115.156-52.926-17.156-17.155-17.156-45.069 0-62.226z"
                                                ></path>
                                            </g>
                                        </svg>
                                    </div>
                                )}
                            </div>
                        </div>
                    )
                })}
                <PromoField codeAplied={codeAplied} userInfo={userInfo} />
            </div>
        )
    }
)
